import {Org} from "../../../resources/org"
import React from "react"
import {Customer} from "../../../resources/customer"
import Icon from "../../../components/Icon/Icon"
import {useModal} from "react-modal-hook"
import {GoLiveModal} from "../GoLiveModal"

interface MoveToUnitLiveProps {
	org: Org
	customers: Customer[]
	refresh: () => void
}
export default function MoveToUnitLive({org, customers, refresh}: MoveToUnitLiveProps) {
	const [showGoLive, hideGoLive] = useModal(() => (
		<GoLiveModal org={org} customers={customers} close={hideGoLive} onSuccess={refresh} />
	))
	return (
		<button className="button button-create move-to-live" onClick={() => showGoLive()}>
			<span> Move to Unit Live! </span>
			<Icon icon={"astronomy-rocket-1--school-science"} size={14} />
		</button>
	)
}
